import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Heart } from "lucide-react";
import { virksomhedsinfo } from "../data";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2D2A26] text-[#FAF8F5] border-t border-[#3D3A35]">
      {/* Hoved footer indhold */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          
          {/* Sektion 1: Om klinikken */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-full overflow-hidden border border-[#FAF8F5]/20 bg-white flex items-center justify-center">
                <img
                  src={virksomhedsinfo.logo}
                  alt="RG Fodpleje Logo"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
            <p className="text-[#B5B0AA] text-sm leading-relaxed max-w-sm">
              Professionel fodpleje i Odense N med fokus på kvalitet, ro, nærvær, sundhed og velvære. Dine fødder er i trygge hænder.
            </p>
            <div className="flex items-center gap-4 pt-2">
              <a
                href={virksomhedsinfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="h-9 w-9 rounded-full bg-[#3D3A35] hover:bg-[#4A5D4E] text-[#FAF8F5] flex items-center justify-center transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href={virksomhedsinfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="h-9 w-9 rounded-full bg-[#3D3A35] hover:bg-[#4A5D4E] text-[#FAF8F5] flex items-center justify-center transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Sektion 2: Hurtige links */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg font-medium tracking-wide border-b border-[#3D3A35] pb-2">
              Hurtige links
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-[#B5B0AA] hover:text-[#FAF8F5] transition-colors duration-200 flex items-center gap-2">
                  <span className="h-1 w-1 rounded-full bg-[#4A5D4E]" />
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/behandlinger" className="text-[#B5B0AA] hover:text-[#FAF8F5] transition-colors duration-200 flex items-center gap-2">
                  <span className="h-1 w-1 rounded-full bg-[#4A5D4E]" />
                  Behandlinger & Priser
                </Link>
              </li>
              <li>
                <Link to="/om-mig" className="text-[#B5B0AA] hover:text-[#FAF8F5] transition-colors duration-200 flex items-center gap-2">
                  <span className="h-1 w-1 rounded-full bg-[#4A5D4E]" />
                  Om mig
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-[#B5B0AA] hover:text-[#FAF8F5] transition-colors duration-200 flex items-center gap-2">
                  <span className="h-1 w-1 rounded-full bg-[#4A5D4E]" />
                  Kontakt
                </Link>
              </li>
              <li className="pt-2">
                <a
                  href="https://rg-fodpleje.planway.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block text-[#FAF8F5] bg-[#4A5D4E] hover:bg-[#3B4C3E] px-4 py-2 rounded-full text-xs font-medium tracking-wide transition-colors duration-200"
                >
                  Book tid online
                </a>
              </li>
            </ul>
          </div>

          {/* Sektion 3: Kontakt & Info */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg font-medium tracking-wide border-b border-[#3D3A35] pb-2">
              Klinikinformation
            </h3>
            <ul className="space-y-3.5 text-sm text-[#B5B0AA]">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#4A5D4E] shrink-0 mt-0.5" />
                <span>
                  Søhusvænget 25,<br />
                  5270 Odense N
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#4A5D4E] shrink-0" />
                <a
                  href={`tel:+45${virksomhedsinfo.telefon.replace(/\s+/g, "")}`}
                  className="hover:text-[#FAF8F5] transition-colors whitespace-nowrap"
                >
                  {virksomhedsinfo.telefon}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#4A5D4E] shrink-0" />
                <a
                  href={`mailto:${virksomhedsinfo.email}`}
                  className="hover:text-[#FAF8F5] transition-colors whitespace-nowrap"
                >
                  {virksomhedsinfo.email}
                </a>
              </li>
              <li className="pt-2 text-xs border-t border-[#3D3A35] text-[#8B857F]">
                <span>Medlem af SADF - Sammenslutningen Af Dansk Fodplejere</span>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bund bar */}
      <div className="bg-[#23201D] py-6 px-4 sm:px-6 lg:px-8 border-t border-[#34312C] text-center text-xs text-[#8B857F]">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
          <p>© {currentYear} {virksomhedsinfo.navn}. Alle rettigheder forbeholdes.</p>
          <p className="flex items-center justify-center gap-1">
            <span>Udviklet af</span>
            <a
              href="https://auxo.dk"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline text-[#A39B94] hover:text-white transition-colors"
            >
              Auxo
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
